import React from 'react';
import { ReactComponent as FigSearchSmComponent } from './FigSearchSm.svg';

const FigSearchSm = (props) => <FigSearchSmComponent {...props} />;

export default FigSearchSm;
